import { Logger } from '../../utils/logger';
import { getDataFromPocket } from '../../utils/pocket';
import { BusinessLocationsRegistry } from './registry-business-locations';

export function sendBusinessLocationEvent() {
    const geo: any = getDataFromPocket('geo', false);

    if (!geo.data?.country?.code) {
        return;
    }

    const descriptor = BusinessLocationsRegistry[geo.data.country.code];
    if (!descriptor) {
        Logger.warn('No descriptor for country', geo.data.country.code);
        return;
    }

    const event = {
        country: geo.data.country.name,
        geography: descriptor[0],
        region: descriptor[1],
        subRegion: descriptor[2],
        budgetRegion: descriptor[3],
    };

    window.dataLayer.push(event);
}
